import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/settings/file_templates/Page";

export const PATH = "/settings/file_templates";

const Home: NextPage = () => (
	<>
		<NskHead title="帳票設定" />
		<Component />
	</>
);

export default Home;
